import { render, staticRenderFns } from "./cadsubgrupos.vue?vue&type=template&id=ff69143a&"
import script from "./cadsubgrupos.vue?vue&type=script&lang=js&"
export * from "./cadsubgrupos.vue?vue&type=script&lang=js&"
import style0 from "./cadsubgrupos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports